import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsis, faCircleXmark } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from 'react-i18next';
import AdminDashboardList from './AdminDashboardList';

function AdminSideBar() {
    const [isOpen, setIsOpen] = useState(false);
    const { i18n } = useTranslation();
    function toggleMenu() { setIsOpen(!isOpen) };

    return (
        <div className="col-1 col-md-2 text-start bg-light-beige">
            <div className="mt-5">
                <div className={`d-block d-sm-none slide-menu-container ${isOpen ? 'open' : ''} ${i18n.language === "ar" ? "slide-menu-container-Ar" : "slide-menu-container-En"}`}>
                    <div className="text-end bg-light-orange text-white fs-6 rounded pe-2 pt-1" onClick={toggleMenu}>
                        {isOpen ? <FontAwesomeIcon icon={faCircleXmark} /> : <FontAwesomeIcon icon={faEllipsis} />}
                    </div>
                    <div className="px-5">
                        <ul
                            className="list-group pt-2">
                            <AdminDashboardList />
                        </ul>
                    </div>
                </div>
                <div className="d-none d-sm-flex flex-wrap justify-content-between">
                    <ul
                        className="list-group pt-2 w-100">
                        <AdminDashboardList />
                    </ul>
                </div>
            </div>
        </div>
    )
}

export { AdminSideBar }